var React = require('react');

function TickWithBlueBgIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"46","height":"46","rx":"23","fill":"#12C9FF","key":0}),React.createElement("path",{"d":"M17 23L21 27L29 19","stroke":"#FCFCFD","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TickWithBlueBgIcon.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = TickWithBlueBgIcon;

TickWithBlueBgIcon.default = TickWithBlueBgIcon;
